"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const protobuf_map_1 = require("./protobuf-map");
// @ts-ignore
const protobuf_1 = require("../generated/protobuf");
function getMessage(message, isAck) {
    if (isAck && !message.isAck) {
        message = Object.assign(Object.assign({}, message), { isAck: true });
    }
    if (message.data === undefined && message.parsedData !== undefined) {
        message.data = JSON.stringify(message.parsedData);
    }
    if (message.requestorData) {
        message.requestorData = JSON.stringify(message.requestorData);
    }
    const serializedMessage = protobuf_map_1.TopicMessage[message.topic].encode(message).finish();
    const x = protobuf_1.Message.encodeDelimited({ topic: message.topic, message: serializedMessage }).finish();
    return x;
}
exports.getMessage = getMessage;
//# sourceMappingURL=message-builder.js.map